(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'PackageBookingMatchClients',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.vax-booking-new-or-existing').change(function adjustedNewOrExisting() {
			var $self       = $(this),
				$row        = $self.parents('.table-row'),
				$new_fields = $row.find('.new-client-field').find("input"),
				client_num  = parseInt($self.data('client_num'));

			if ($self.val() === 'new') {
				newClient($row, $new_fields, client_num);
			} else {
				existingClient($row, $new_fields);
			}
		});

		$('.toggle-client-name').on("click", function cname() {
			var $self       = $(this),
				$row        = $self.parents('.table-row'),
				$new_fields = $row.find('.new-client-field').find("input");

			existingClient($row, $new_fields);
		});

		$('.pointer').on("click", function tprimary() {
			var $self           = $(this),
				$col            = $self.parents('.primary-toggle'),
				$row            = $self.parents('.table-row'),
				$radio          = $col.find('input:radio'),
				$all_pointers   = $('.primary-toggle .pointer'),
				icon_on         = $self.data('on-class'),
				icon_off        = $self.data('off-class'),
				placeholder_txt = $('#packagebookingmatchclients-neworexistingclient-0-email').data('ph');

			$('.new-client-input').attr("placeholder", "");

			$radio.trigger('click');

			// only new clients need the placeholder text
			if ($row.find('.vax-booking-new-or-existing').val() === "new") {
				$('#packagebookingmatchclients-neworexistingclient-' + $radio.val() + '-email').attr("placeholder", placeholder_txt);
				$('#packagebookingmatchclients-neworexistingclient-' + $radio.val() + '-phone').attr("placeholder", placeholder_txt);
			}

			$all_pointers.attr("class", icon_off);

			if ($radio.prop("checked")) {
				$self.attr("class", icon_on);
			}
		});

		function newClient($row, $new_fields, row_count)
		{
			var $radio = $row.find('.primary-toggle input:radio');

			$row.find(".pre-selected-client-typeahead").css('text-decoration', 'line-through');
			$row.find(".reset-typeahead").find('a').trigger('click');
			$row.find(".existing-client").prop('disabled', true);
			$new_fields.prop('disabled', false);

			// only the primary client needs the required placeholder text
			if ($radio.is(':checked')) {
				$new_fields.attr('placeholder', $new_fields.data('ph'));
			}
		}

		function existingClient($row, $new_fields)
		{
			$row.find(".existing-client").prop('disabled', false);

			$new_fields.val('');
			$new_fields.prop('disabled', true);
			$new_fields.attr('placeholder', '');

			if ($row.find(".pre-selected-client-typeahead")) {
				$row.find(".toggle-client-name").trigger('click');
			}
		}
	};

}(jQuery, window.Adzuki || {}));
